// SPDX-FileCopyrightText: 2017-2024 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import { QueryClient } from '@tanstack/react-query'

import { shouldRetry } from 'lib-common/query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      retry: shouldRetry
    },
    mutations: {
      networkMode: 'always'
    }
  }
})

export { QueryClientProvider } from '@tanstack/react-query'
